import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import Collapsable from '../Collapsable'

export const ScrollTarget = styled.div`
  display: flex;
  position: absolute;
  height: 1rem;
  width: 100vw;
  pointer-events: none;
  margin-top: -18rem;

  @media ${mq(sizes.desktop)} {
    margin-top: -19.5rem;
  }
`

export const Collapse = styled(Collapsable)``

export const SectionTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH2_23}
  padding: 0;
  margin: 0;
  text-align: center;

  &::first-letter {
    text-transform: uppercase;
  }

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.titleH2_30}
  }
`

export const Inner = styled.div`
  margin: 3.5rem 0 0.5rem 0;

  @media ${mq(sizes.desktop)} {
    margin: 2rem 0;
  }
`

export const EmptyMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NoMenuText = styled.p`
  ${({ theme }) => theme.textStyles.text_bold_18}
  margin-bottom: 1.5rem;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_32}
    margin-bottom: 3.5rem;
    margin-top: 4rem;
  }
`
export const Suggestion = styled.div`
  display: flex;
  flex-direction: row;
  background: ${({ theme }) => theme.colors.wildSand};
  padding: 2rem;
  border-radius: 2rem;
  margin-bottom: 2rem;

  @media ${mq(sizes.desktop)} {
    max-width: 84rem;
    padding: 5rem;
    margin-bottom: 3rem;
  }
`

export const SuggestionText = styled.div`
  ${({ theme }) => theme.textStyles.text_16}
  margin-left: 1.5rem;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_24}
    margin-left: 6rem;
  }
`
export const ChangeMyMind = styled.p`
  ${({ theme }) => theme.textStyles.text_bold_18}
  margin-bottom: 0.8rem;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_32}
    margin-bottom: 2rem;
  }
`

export const SuggestionIcon = styled.div`
  flex-shrink: 0;
  width: 6.8rem;
  height: 6.8rem;

  @media ${mq(sizes.desktop)} {
    width: 13rem;
    height: 13rem;
  }
`
